<!-- 清单 -->
<template>
    <div class='inventory'>
        <el-form :model="form" :rules="form.rules" ref="form">
            <div v-if="parentCodeType == $root.gc_category">
                <div>
                    <el-table :max-height="maxHeight" ref="tableData1" key="tableData1" :data="form.tableData1"
                              @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column type="selection" width="55" v-if="isSelection">
                        </el-table-column>
                        <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="报价类型" width="140px" fixed v-if="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                        </el-table-column> -->
                        <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode"/>
                        <el-table-column label="分部分项名称" width="140px" prop="subitemName">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.subitemName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="工程项名称" width="140px" prop="matterName" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="工作/工艺内容描述/规格型号参数" width="140px" prop="matterRequired">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand" v-if="false">
                        </el-table-column>
                        <!-- <el-table-column label="投标品牌" width="140px" prop="brandName">
                        </el-table-column> -->
                        <el-table-column label="单位" width="60px" prop="unitName">
                        </el-table-column>
                        <el-table-column label="数量" width="80px" prop="quantities">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData1.' + scope.$index + '.quantities'"
                                              :rules='form.rules.quantities' v-if="editable && scope.row.dealListStatus != 1">
                                    <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                              v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                                </el-form-item>
                                <span v-else>
                                    {{ scope.row.quantities }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData1.' + scope.$index + '.actualQuantities'"
                                              :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                    <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,1)"
                                    v-if="isOrderSettle == 5 || isOrderSettle == 7" v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                    <span v-else>{{ scope.row.actualQuantities }}</span>
                                </el-form-item>
                                <span v-else>{{ scope.row.actualQuantities }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="供应单价（元）" width="140px" prop="supplyUnitPrice" v-if="false">
                        </el-table-column>
                        <el-table-column label="安装单价（元）" width="140px" prop="installUnitPrice" v-if="false">
                        </el-table-column>
                        <el-table-column label="不含税综合单价（元）" width="140px" prop="unitAmountExclTax">
                        </el-table-column>
                        <el-table-column label="含税综合单价（元）" width="140px" prop="unitAmountWithTax">
                        </el-table-column>
                        <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                        </el-table-column> -->
                        <el-table-column label="税金（元）" width="140px">
                            <template slot-scope="scope">
                                {{
                                    $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax" >
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax"
                            v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="专业分类" width="140px" prop="categoryName">
                        </el-table-column>
                        <el-table-column label="事项说明" width="80px" prop="remarks" fixed="right">
                            <template slot-scope="scope">
                                <el-form-item v-if="editable && scope.row.dealListStatus != 1">
                                    <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                              v-model="scope.row.remarks"></el-input>
                                </el-form-item>
                                <span v-else>
                                    {{ scope.row.remarks }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="规格尺寸" width="140px" prop="speciificationSize">
                            <template slot-scope="scope">
                                <el-form-item v-if="editable && scope.row.dealListStatus != 1">
                                    <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                              v-model="scope.row.speciificationSize"></el-input>
                                </el-form-item>
                                <span v-else>
                                    {{ scope.row.speciificationSize }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- orderStatus!= 0 &&  -->
                        <el-table-column label="状态" width="60px" fixed="right" v-if="editable && isOrderSettle!=1" prop="dealListStatus">
                            <template slot-scope="scope">
                                <div v-if="scope.row.dealListStatus == 1" style="color:#67c23a;">合格</div>
                                <div v-if="scope.row.dealListStatus == 2" style="color:#f56c6c;">修改</div>
                                <div v-if="scope.row.dealListStatus == 3" style="color:#e6a23c;">已修改</div>
                                <div v-if="scope.row.dealListStatus == 4" style="color:#409eff;">新增</div>
                                <!-- <el-button type="text" size="mini" >正常</el-button> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="说明" width="80px" prop="dealListRemarks" fixed="right" v-if="editable  && isOrderSettle!=1">
                            <template slot-scope="scope">
                                <el-input
                                    type="text"
                                    disabled
                                    size="mini"
                                    placeholder=""
                                    v-model="scope.row.dealListRemarks">
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="60px" fixed="right" v-if="editable && isOrderSettle!=1">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="del(scope.$index, 1)" v-if="scope.row.dealListStatus != 1"> 删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div v-else-if="parentCodeType == $root.wzsb_category">
                <el-table :max-height="maxHeight" ref="tableData3" key="tableData3" :data="form.tableData3"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <!--  v-if="isSelection" -->
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标事项" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标需求内容描述/材质工艺等要求/规格型号" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="规格尺寸" width="140px" prop="speciificationSize">
                    </el-table-column> -->
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand" v-if="false">
                    </el-table-column>
					<el-table-column label="投标品牌" width="140px" prop="brandName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.brandName}}</span>
                        </template>
					</el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData3.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1  && scope.row.dealListStatus != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                                {{ scope.row.quantities }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData3.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5 || isOrderSettle == 7|| isOrderSettle == 8">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,3)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                            <span v-else>{{ scope.row.actualQuantities }}</span>

                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                        <template slot-scope="scope">
                            {{$root.mathDiv($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accAdd($root.accDiv(scope.row.taxRatio, 100),1))}}
                            <!-- {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }} -->
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 3)"  v-if="scope.row.dealListStatus != 1"> 删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="100px" fixed="right" v-if="editable && isOrderSettle!=1" prop="dealListStatus">
                        <template slot-scope="scope">
                            <div v-if="scope.row.dealListStatus == 1" style="color:#67c23a;">合格</div>
                            <div v-if="scope.row.dealListStatus == 2" style="color:#f56c6c;">修改</div>
                            <div v-if="scope.row.dealListStatus == 3" style="color:#e6a23c;">已修改</div>
                            <div v-if="scope.row.dealListStatus == 4" style="color:#409eff;">新增</div>
                            <!-- <el-button type="text" size="mini" >正常</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.yxtg_category">
                <el-table :max-height="maxHeight" ref="tableData4" key="tableData4" :data="form.tableData4"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标内容/需求" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="区域/位置" width="140px" prop="areaLocations">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.areaLocations}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="制作工艺（工艺及材料描述详细）/事项内容要求描述" width="140px" prop="matterDesc">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterDesc}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData4.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                                {{ scope.row.quantities }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="天数" width="140px" prop="dayAmount">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData4.' + scope.$index + '.dayAmount'"
                                          :rules='form.rules.dayAmount' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.dayAmount" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                                {{ scope.row.dayAmount }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData4.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,4)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="天数" width="140px" prop="dayAmount">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData4.' + scope.$index + '.dayAmount'"
                                          :rules='form.rules.quantities' v-if="editable">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model.number="scope.row.dayAmount"></el-input>
                            </el-form-item>
                            <span v-else>
                                {{ scope.row.dayAmount }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMuls(scope.row.unitAmountExclTax, scope.row.quantities, scope.row.dayAmount) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                        <template slot-scope="scope">
                            {{ $root.accMuls(scope.row.unitAmountWithTax, scope.row.quantities, scope.row.dayAmount) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 4)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.wyfw_category">
                <div v-if="codeType == $root.wyfwba_category || codeType == $root.wyfwbj_category">
                    <div v-if="operationEnable">
                        <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData5">
                            <i class="iconfont iconjiahaoyou"></i> 添加
                        </el-button>
                    </div>
                    <el-table :max-height="maxHeight" ref="tableData5" key="tableData5" :data="form.tableData5"
                              @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column type="selection" width="55" v-if="isSelection">
                        </el-table-column>
                        <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="报价类型" width="140px" fixed v-if="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="分类索引" width="140px" prop="subitemName">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.subitemName}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                        </el-table-column> -->
                        <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="岗位人员要求" width="140px" prop="matterName">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="客用品/清洁用品/岗位用品需求" width="140px" prop="matterRequired">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位" width="140px" prop="unitName">
                        </el-table-column>
                        <el-table-column label="岗位时间" width="140px" prop="postTime">
                        </el-table-column>
                        <el-table-column label="服务时长(月)" width="140px" prop="serviceTime">
                        </el-table-column>
                        <el-table-column label="岗位数量" width="140px" prop="quantities">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData5.' + scope.$index + '.quantities'"
                                              :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                    <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                              v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                                </el-form-item>
                                <span v-else>
                                    {{ scope.row.quantities }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际岗位数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData5.' + scope.$index + '.actualQuantities'"
                                              :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5 || isOrderSettle == 7 || isOrderSettle == 8 ">
                                    <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,5)"
                                     v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                              v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                              <span v-else>{{ scope.row.actualQuantities }}</span>
                                </el-form-item>
                                <span v-else>{{ scope.row.actualQuantities }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="工时不含税单价（元/小时/岗）" width="140px" prop="unitHourAmountExclTax">
                        </el-table-column>
                        <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                        </el-table-column>
                        <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                        </el-table-column>
                        <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                        </el-table-column> -->
                        <el-table-column label="税金（元）" width="140px">
                            <template slot-scope="scope">
                                {{$root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))}}
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                            <template slot-scope="scope">
                                {{ $root.accMuls(scope.row.unitAmountExclTax, scope.row.quantities, scope.row.dayAmount) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                            <template slot-scope="scope">
                                {{ $root.accMuls(scope.row.unitAmountWithTax, scope.row.quantities, scope.row.dayAmount) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                           </template>
                        </el-table-column>
                        <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax"
                            v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                            </template>s
                        </el-table-column>
                        <el-table-column label="专业分类" width="140px" prop="categoryName">
                        </el-table-column>
                        <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="del(scope.$index, 5)"> 删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else>
                    <el-table :max-height="maxHeight" ref="tableData6" key="tableData6" :data="form.tableData6"
                              @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column type="selection" width="55" v-if="isSelection">
                        </el-table-column>
                        <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="报价类型" width="140px" fixed v-if="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="分类索引" width="140px" prop="subitemName">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.subitemName}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                        </el-table-column> -->
                        <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="服务事项" width="140px" prop="matterName">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="服务内容要求描述" width="140px" prop="matterRequired">
                            <template slot-scope="scope">
                                <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务频次" width="140px" prop="maintenanceFrequency">
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="设备/服务参数描述" width="140px" prop="matterDesc">
                        </el-table-column>
                        <el-table-column label="数量" width="140px" prop="quantities">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData6.' + scope.$index + '.quantities'"
                                              :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                    <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                              v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                                </el-form-item>
                                <span v-else>
                                    {{ scope.row.quantities }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                <el-form-item :prop="'tableData6.' + scope.$index + '.actualQuantities'"
                                              :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                    <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,6)"
                                    v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                              v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                              <span v-else>{{ scope.row.actualQuantities }}</span>
                                </el-form-item>
                                <span v-else>{{ scope.row.actualQuantities }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位" width="140px" prop="unitName">
                        </el-table-column>
                        <el-table-column label="不含税单价（元/月）" width="140px" prop="unitAmountExclTax">
                        </el-table-column>
                        <el-table-column label="税率/服务费率（%）" width="140px" prop="taxRatio">
                        </el-table-column>
                        <el-table-column label="含税单价（元/月）" width="140px" prop="unitAmountWithTax">
                        </el-table-column>
                        <el-table-column label="税金（元）" width="140px">
                            <template slot-scope="scope">
                                {{
                                $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                           </template>
                        </el-table-column>
                        <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax"
                            v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                            </template>s
                        </el-table-column>
                        <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                        </el-table-column>
                        <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                        </el-table-column> -->
                        <el-table-column label="专业分类" width="140px" prop="categoryName">
                        </el-table-column>
                        <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="del(scope.$index, 6)"> 删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div v-else-if="parentCodeType == $root.wywb_category">
                <el-table :max-height="maxHeight" ref="tableData7" key="tableData7" :data="form.tableData7"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分类索引" width="140px" prop="subitemName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.subitemName}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="服务事项" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="服务内容要求描述" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务频次" width="140px" prop="maintenanceFrequency">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="设备/服务参数描述" width="140px" prop="matterDesc">
                    </el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData7.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData7.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,7)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元/月）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率/服务费率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元/月）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax"
                            v-if="isOrderSettle">
                            <template slot-scope="scope">
                                {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                            </template>s
                        </el-table-column>
                    <el-table-column label="空调主机（冷量）" width="140px" prop="conditionerHost">
                    </el-table-column>
                    <el-table-column label="高压柜/低压柜（KVA）" width="140px" prop="highLowVoltage"
                        v-if="this.codeType == this.$root.wywb_kt_category">
                    </el-table-column>
                    <el-table-column label="建筑面积（㎡）" width="140px" prop="constructArea"
                        v-if="this.codeType == this.$root.wywb_pds_category">
                    </el-table-column>
                    <el-table-column label="平米单价（元/平米）" width="140px" prop="unitPricePerSquare">
                    </el-table-column>

                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 7)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.sj_category">
                <el-table :max-height="maxHeight" ref="tableData8" key="tableData8" :data="form.tableData8"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="设计阶段/设计内容/设计范围/设计深度/设计系统" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData8.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-else>
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData8.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupActualQuantitiesCallback(scope.row,8)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="设计面积（㎡）" width="140px" prop="designArea">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>

                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 8)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.gw_category">
                <div v-if="operationEnable">
                    <el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData9"><i
                        class="iconfont iconjiahaoyou"></i> 添加
                    </el-button>
                </div>
                <el-table :max-height="maxHeight" ref="tableData9" key="tableData9" :data="form.tableData9"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="顾问阶段/顾问服务内容/顾问范围/顾问系统/项目" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData9.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-else>
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData9.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupActualQuantitiesCallback(scope.row,9)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span  v-else :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）/服务费率" width="140px" prop="unitAmountWithTax">
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 9)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.xx_category">
                <el-table :max-height="maxHeight" ref="tableData10" key="tableData10" :data="form.tableData10"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标事项" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标需求内容描述/材质工艺等要求/服务内容" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="规格型号尺寸/服务要求" width="140px" prop="specificationServiceRequirements">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.specificationServiceRequirements}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand" v-if="false">
                    </el-table-column>
					<el-table-column label="投标品牌" width="140px" prop="brandName">
					</el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData10.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData10.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,10)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 10)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.xz_category">
                <el-table :max-height="maxHeight" ref="tableData11" key="tableData11" :data="form.tableData11"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column type="selection" width="55" v-if="isSelection">
                    </el-table-column>
                    <el-table-column label="序号" type="index" fixed="left" width="100px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标事项" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标需求内容描述/材质工艺等要求" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="规格型号尺寸" width="140px" prop="specificationServiceRequirements">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.specificationServiceRequirements}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand" v-if="false">
                    </el-table-column>
					<el-table-column label="投标品牌" width="140px" prop="brandName">
					</el-table-column>
                    <el-table-column label="数量" width="140px" prop="quantities">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData11.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else>
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData11.' + scope.$index + '.actualQuantities'"
                                          :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,11)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="140px" prop="unitName">
                    </el-table-column>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax">
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                    </el-table-column>

                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px">
                        <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="操作" width="100px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 11)"> 删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else>
                <el-table :max-height="maxHeight" ref="tableData12" key="tableData12" :data="form.tableData12"
                          @selection-change="handleSelectionChange" @select="select" @select-all="selectAll"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 10px;">
                    <!-- <el-table-column  width="55" :selectable="selectable" :label="isSelection ? '选择' : '序号'"
                    :type="isSelection ? 'selection' : 'index'">
                    </el-table-column> -->
                    <el-table-column label="选择" width="60px" prop=""  v-if="isSelection">
                        <template slot-scope="scope">
                            <div class="el-icon-plus" @click="add(scope.row)" style="cursor: pointer;"></div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column  width="55" :selectable="selectable" label=""
                    type="selection">
                    </el-table-column> -->
                    <!--  type="selection"  v-if="isSelection" -->
                    <!--  -->
                    <el-table-column label="序号" type="index" fixed="left" width="30px" v-else>
                        <template slot-scope="scope">
                            <el-form-item>
                                <span v-if="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1" style="color: red;margin-right:8px;font-weight:700">*</span><span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed v-if="false">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="!justOrder" label="适用区域" width="140px" prop="regionalCompanyName">
                    </el-table-column> -->
                    <el-table-column v-if="false" label="子目编码" width="140px" prop="priceLibraryCode">

                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标事项" width="140px" prop="matterName">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip label="招标需求内容描述/材质工艺等要求/品牌规格型号" width="140px" prop="matterRequired">
                        <template slot-scope="scope">
                            <span :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">{{scope.row.matterRequired}}</span>
                        </template>
                    </el-table-column>
                    <!--  v-if="editable && isOrderSettle!=1" -->
                    <el-table-column label="数量" width="80px" prop="quantities" v-if="editable || isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData12.' + scope.$index + '.quantities'"
                                          :rules='form.rules.quantities' v-if="editable && isOrderSettle!=1 && scope.row.dealListStatus != 1">
                                <el-input size="mini" :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.quantities" :oninput="$root.numberFilter2"></el-input>
                            </el-form-item>
                            <span v-else :class="pageType == 'orderAdd' && scope.row.doesItExist &&  scope.row.doesItExist== 1 ? 'isRed' : ''">
                          {{ scope.row.quantities }}
                      </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实际数量" width="140px" prop="actualQuantities" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            <el-form-item :prop="'tableData12.' + scope.$index + '.actualQuantities'"
                                           :rules='form.rules.actualQuantities' v-if="isOrderSettle == 5|| isOrderSettle == 7 || isOrderSettle == 8 || isOrderSettle == 71">
                                <el-input size="mini" @keyup.native="keyupActualQuantitiesCallback(scope.row,12)"
                                v-if="isOrderSettle == 5 || isOrderSettle == 7 || isOrderSettle == 71"
                                          v-model="scope.row.actualQuantities" :oninput="$root.numberFilter2"></el-input>
                                          <span v-else>{{ scope.row.actualQuantities }}</span>
                            </el-form-item>
                            <span v-else>{{ scope.row.actualQuantities }}</span>
                            <!-- <span>{{ scope.row.actualQuantities }}</span> -->
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="投标品牌" width="140px" prop="brandName">
                        </el-table-column> -->
                    <el-table-column label="单位" width="60px" prop="unitName">
                        <!-- <template slot-scope="scope">
                            <span>{{scope.row.unitName}}</span>
                        </template> -->
                    </el-table-column>
                    <el-table-column label="不含税单价（元/月）" width="140px" prop="unitAmountExclTax">
                        <!-- <template slot-scope="scope">
                            <span>{{scope.row.unitAmountExclTax}}</span>
                        </template> -->
                    </el-table-column>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax">
                        <!-- <template slot-scope="scope">
                            <span>{{scope.row.unitAmountWithTax}}</span>
                        </template> -->
                    </el-table-column>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio">
                        <!-- <template slot-scope="scope">
                            <span>{{scope.row.taxRatio}}</span>
                        </template> -->
                    </el-table-column>

                    <!-- <el-table-column v-if="!justOrder" label="招标项" width="140px" prop="bidItemName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库人" width="140px" prop="storeUserName">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="入库时间" width="140px" prop="storeTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效开始时间" width="140px" prop="effectStartTime">
                    </el-table-column>
                    <el-table-column v-if="!justOrder" label="报价有效截止时间" width="140px" prop="effectEndTime">
                    </el-table-column> -->
                    <el-table-column label="税金（元）" width="140px"  prop="taxRatioAmount">
                        <!-- <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities)) }}
                        </template> -->
                        <!-- <template slot-scope="scope">
                            {{
                            $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.quantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities))
                            }}
                        </template> -->
                    </el-table-column>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax" >
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.quantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际税金（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMinus($root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities), $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities)) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际不含税合价（元）" width="140px" prop="actualAmountExclTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountExclTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="实际含税合价（元）" width="140px" prop="actualAmountWithTax" v-if="isOrderSettle">
                        <template slot-scope="scope">
                            {{ $root.accMul(scope.row.unitAmountWithTax, scope.row.actualQuantities) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="专业分类" width="140px" prop="categoryName">
                    </el-table-column>
                    <el-table-column label="事项说明" width="80px" prop="remarks" fixed="right"  v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-form-item v-if="editable && isOrderSettle!=1 && scope.row.dealListStatus != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                          v-model="scope.row.remarks"></el-input>
                            </el-form-item>
                            <span v-else>{{ scope.row.remarks }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="50px" fixed="right" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="del(scope.$index, 12)" v-if=" scope.row.dealListStatus != 1"> 删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格尺寸" width="140px" prop="speciificationSize" v-if="editable && isOrderSettle!=1">
                        <template slot-scope="scope">
                            <el-form-item v-if="editable && scope.row.dealListStatus != 1">
                                <el-input size="mini" @keyup.native="keyupCallback(scope.row)"
                                            v-model="scope.row.speciificationSize"></el-input>
                            </el-form-item>
                            <span v-else>
                                {{ scope.row.speciificationSize }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('priceTable', {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: ['code', 'parentCode', 'page', 'isSelection', 'editable','isOrderSettle','maxHeight','orderStatus'],
    computed: {
        justOrder() {
            return this.pageType == 'orderAdd';
        },
        isReadOnlys(){
                if(this.type == 7 || this.type == 5 || this.type == 8|| this.type == 71){
                    return false;
                }else {
                    return true;
                }
            },
    },
    watch: {
        code(val) {
            this.codeType = val;
        },
        page(val) {
            this.pageType = val;
        },
        parentCode(val) {
            this.parentCodeType = val;
        },
        isOrderSettle(val){
            if(val == 71){
                this.form.rules = this.formateRequiredRules(['actualQuantities']);
            }else {
                this.form.rules = this.formateRequiredRules(['quantities']);
            }
        },
        // orderStatus(val) {
        //     console.log(val)
        //     // this.orderStatus = val
        //     // console.log('1111111111',this.orderStatus)
        // }
    },
    data() {
        return {
            categoryName: '',
            codeType: '',
            parentCodeType: '',
            pageType: '',
            selectableSetData: [],
            form: {
                rules: {},
                tableData1: [],
                tableData2: [],
                tableData3: [],
                tableData4: [],
                tableData5: [],
                tableData6: [],
                tableData7: [],
                tableData8: [],
                tableData9: [],
                tableData10: [],
                tableData11: [],
                tableData12: [],
            }
        }
    },
    //方法集合
    methods: {
        submitFormFnc(formName) {
            let that = this;
            var f = function () {
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if (Array.isArray(that.$refs[formName])) {
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if (valid) {
                            resolve(true);
                        } else {
                            reject('请正确填写清单必填信息！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        submitFormPromise(formName) {
            return this.submitFormFnc(formName)();
        },
        keyupCallback(row) {

        },
        keyupActualQuantitiesCallback(row,type) {
            // debugger
            let index = 0;
            let total = 0;
            let totalTax = 0;
            let data = this.form['tableData'+type]
            data.forEach(item=>{
                index++;
                if (item.actualQuantities){
                    total += parseFloat(item.unitAmountExclTax) * parseInt(item.actualQuantities)
                    totalTax += parseFloat(item.unitAmountWithTax) * parseInt(item.actualQuantities)
                }
                if (index == data.length){
                    this.$emit("totalBack",total,totalTax)
                }
            })
        },
        del(index, type) {
            this.form['tableData' + type].splice(index, 1);
            this.$emit('deleteItem')
        },
        add (row){
            // console.log(row)
            this.$emit('func',row)
        },
        toggleSelection(rows) {
            // console.log(rows)
            let table = this.$refs.tableData12;
            let tableData = this.form.tableData12;

            if (this.parentCodeType == this.$root.gc_category) {
                table = this.$refs.tableData1;
                tableData = this.form.tableData1;
            } else if (this.parentCodeType == this.$root.wzsb_category) {
                table = this.$refs.tableData3;
                tableData = this.form.tableData3;
            } else if (this.parentCodeType == this.$root.yxtg_category) {
                table = this.$refs.tableData4;
                tableData = this.form.tableData4;
            } else if (this.parentCodeType == this.$root.wyfw_category) {
                    if (this.codeType == this.$root.wyfwba_category || this.codeType == this.$root
                        .wyfwbj_category) {
                    table = this.$refs.tableData5;
                    tableData = this.form.tableData5;
                } else {
                    table = this.$refs.tableData6;
                    tableData = this.form.tableData6;
                }
            } else if (this.parentCodeType == this.$root.wywb_category) {
                table = this.$refs.tableData7;
                tableData = this.form.tableData7;
            } else if (this.parentCodeType == this.$root.sj_category) {
                table = this.$refs.tableData8;
                tableData = this.form.tableData8;
            } else if (this.parentCodeType == this.$root.gw_category) {
                table = this.$refs.tableData9;
                tableData = this.form.tableData9;
            } else if (this.parentCodeType == this.$root.xx_category) {
                table = this.$refs.tableData10;
                tableData = this.form.tableData10;
            } else if (this.parentCodeType == this.$root.xz_category) {
                table = this.$refs.tableData11;
                tableData = this.form.tableData11;
            } else {
                table = this.$refs.tableData12;
                tableData = this.form.tableData12;
            }

            this.$nextTick(() => {
                if (rows) {
                    rows.forEach(row => {
                        if(row) {
                            table.toggleRowSelection(row, true);
                        }

                    });
                } else {
                    table.clearSelection();
                }
            })
        },
        selectAll(selection) {
            this.$emit('select-all', selection);
        },
        select(selection, row) {
            this.$emit('select', selection, row);
        },
        handleSelectionChange(val) {
            this.$emit('selection-change', val);
        },
        // 判断是否禁用
        selectable(row, index) { // 有ID才能选，为空没ID则不能选择
            let val = this.selectableSetData.find(item => { return item.priceLibraryClausesId == row.priceLibraryClausesId })
            // if (this.orderStatus == 0 || this.orderStatus == '') {
            //     if (val) {
            //         val.dealListStatus = 0
            //         }
            // } else if (this.orderStatus == 0 && val.dealListStatus != 0) {
            //     // if (val.dealListStatus != 0 ) {
            //         val.dealListStatus = val.dealListStatus
            //     // }
            // }
            if (val) {
                if (val.dealListStatus == 1) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        formateRequiredRules(attrs) {
            let rules = {};
            let numberAttrs = ['quantities','actualQuantities'];

            attrs.forEach((name, index) => {
                rules[name] = [{
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                }];
                if (numberAttrs.indexOf(name) != -1) {
                        rules[name].push({
                            pattern: /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,3}$)/g,
                            message: '必须为有效数值',
                            trigger: 'blur'
                        });
                        rules[name].push({
                            pattern: /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,3}$)/g,
                            message: '必须为有效数值',
                            trigger: 'blur'
                        });
                }
            });
            return rules;
        },
        setData(list1, obj,setData) {
            // console.log(list1, obj,setData)
            list1 = list1 || [];
            this.parentCodeType = obj.parentCategoryCode;
            // console.log(this.parentCodeType)
            this.codeType = obj.categoryCode
            this.selectableSetData = setData
            // console.log(this.selectableSetData)

            if (this.parentCodeType == this.$root.gc_category) {
                this.form.tableData1 = list1;
                // this.form.tableData2 = list2;
            } else if (this.parentCodeType == this.$root.wzsb_category) {
                this.form.tableData3 = list1;
            } else if (this.parentCodeType == this.$root.yxtg_category) {
                this.form.tableData4 = list1;
            } else if (this.parentCodeType == this.$root.wyfw_category) {
                    if (this.codeType == this.$root.wyfwba_category || this.codeType == this.$root
                        .wyfwbj_category) {
                    this.form.tableData5 = list1;
                } else {
                    this.form.tableData6 = list1;
                }
            } else if (this.parentCodeType == this.$root.wywb_category) {
                this.form.tableData7 = list1;
            } else if (this.parentCodeType == this.$root.sj_category) {
                this.form.tableData8 = list1;
            } else if (this.parentCodeType == this.$root.gw_category) {
                this.form.tableData9 = list1;
            } else if (this.parentCodeType == this.$root.xx_category) {
                this.form.tableData10 = list1;
            } else if (this.parentCodeType == this.$root.xz_category) {
                this.form.tableData11 = list1;
            } else {
                this.form.tableData12 = list1;
                // 定位到表格最底部
                // this.$refs.tableData12.bodyWrapper.scrollTop =this.$refs.tableData12.bodyWrapper.scrollHeight
                this.$nextTick(() => {
                    // console.log(11111111111)
                    this.$refs.tableData12.bodyWrapper.scrollTop =this.$refs.tableData12.bodyWrapper.scrollHeight
                })

            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // debugger;
        this.pageType = this.page;
        this.codeType = this.code;
        this.parentCodeType = this.parentCode;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        if(this.isOrderSettle == 5 || this.isOrderSettle == 7 || this.isOrderSettle == 8 || this.isOrderSettle == 71 ){
            this.form.rules = this.formateRequiredRules(['actualQuantities']);
        }else {
            this.form.rules = this.formateRequiredRules(['quantities']);
        }
    },
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
@import '../../../assets/_var.scss';

.inventory /deep/ {
    margin-top: -15px;

    .el-input__inner {
        border: 1px solid #C4C4C4 !important;
        border-radius: 0px !important;
        padding: 0;
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .el-form-item.is-error .el-input__inner {
        border-color: #f56c6c !important;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .el-table--mini th, .el-table--mini td {
        padding: 0px;
    }

    .el-table td .cell{
        padding: 0;
        line-height: 30px !important;
    }

    .el-table th .cell{
        padding: 0;
        line-height: 15px !important;
    }


}
.isRed /deep/ {
    color: red;
    font-weight: 700;
    .el-input__inner {
        color: red;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/components/priceTable.vue